import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useTenantNavigate from "../hooks/useTenantNavigate";
import { FileExclamationOutlined } from "@ant-design/icons";
import { Checkbox, Spin } from "antd";

export const Table = ({
  columns,
  data,
  limit = 10,
  limitStart = 0,
  totalRecords = 0,
  setLimitStart,
  onPageChange = () => {},
  rowRedirection,
  isPagination = 1,
  serviceType = null,
  isLoading = false,
  type = null,
  selectedIds = [],
  setSelectedIds = () => {},
}) => {
  const navigate = useTenantNavigate();
  const { clientId } = useParams();
  console.log("TOTAL RECORDS", totalRecords);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const calculatedTotalPages = Math.ceil(totalRecords / limit) || 1;
    const calculatedCurrentPage = Math.floor(limitStart / limit) + 1;

    if (calculatedCurrentPage > calculatedTotalPages) {
      setLimitStart(0);
      setCurrentPage(1);
      setTotalPages(calculatedTotalPages);
    } else {
      setCurrentPage(calculatedCurrentPage);
      setTotalPages(calculatedTotalPages);
    }

    console.log(
      "LIMITTT ",
      limit,
      "LIMIT START",
      limitStart,
      "TOTAL RECORDS",
      totalRecords,
      "TOTAL PAGES",
      calculatedTotalPages,
      "CURRENT PAGE",
      calculatedCurrentPage
    );
  }, [limitStart, limit, totalRecords]);

  const contentStyle = {
    padding: 50,
    background: "rgba(0, 0, 0, 0.05)",
    borderRadius: 4,
    minHeight: "40vh",
  };

  const handleRowClick = (data) => {
    if (rowRedirection && typeof rowRedirection === "function") {
      if (serviceType === "income-tax" && type === "clients") {
        navigate(`/${serviceType}/client-view/${data.id || data.name}`);
      } else if (serviceType === "tds" && type === "clients") {
        navigate(`/${serviceType}/client-view/${data.id || data.name}`);
      } else if (serviceType === "gstin" && type === "clients") {
        navigate(`/${serviceType}/client-view/${data.id || data.name}`);
      } else {
        navigate(rowRedirection(data));
      }
    } else if (rowRedirection && typeof rowRedirection === "string") {
      const clientParam = clientId ? `&clientId=${clientId}` : "";
      // Propagate the source filter (e.g. ?type=open_notices) from the
      // current list URL onto the detail URL so the detail page's
      // breadcrumb can show "Open Notices" instead of the generic
      // "E-Proceedings". Same pattern as `clientParam` above. Empty
      // string when navigating from a non-filtered list (e.g. Clients).
      const _params = new URLSearchParams(window.location.search);
      const _sourceType = _params.get("type");
      const typeParam = _sourceType
        ? `&type=${encodeURIComponent(_sourceType)}`
        : "";
      if (type === "eproceeding") {
        navigate(
          `${rowRedirection}?proceedingID=${
            data?.name
          }&formType=eproceedings${clientParam}${typeParam}`
        );
      } else if (type === "failed_login") {
        navigate(
          `${rowRedirection}?failedLoginID=${
            data?.name
          }&formType=failedLogin${clientParam}${typeParam}`
        );
      } else if (type === "responseoutstandings") {
        navigate(
          `${rowRedirection}?responseID=${
            data?.name
          }&formType=responseOutstandings${clientParam}${typeParam}`
        );
      } else if (type === "notices" && serviceType === "gstin") {
        if (data.notice_type == "Additional Notices") {
          navigate(
            `${rowRedirection}?additionalNoticeID=${
              data?.name
            }&formType=additionalNotices${clientParam}${typeParam}`
          );
        } else {
          navigate(
            `${rowRedirection}?noticeID=${
              data?.name
            }&formType=notices${clientParam}${typeParam}`
          );
        }
      } else if (type === "notices" && serviceType === "tds") {
        navigate(
          `${rowRedirection}?tdsNoticeID=${
            data?.name
          }&formType=tdsNotices${clientParam}${typeParam}`
        );
      } else if (type === "additional-notices" && serviceType === "gstin") {
        navigate(
          `${rowRedirection}?additionalNoticeID=${
            data?.name
          }&formType=additionalNotices${clientParam}${typeParam}`
        );
      } else {
        navigate(rowRedirection);
      }
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allClientIds = data.map((row) => row.name);
      setSelectedIds(allClientIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectClient = (clientId) => {
    setSelectedIds((prev) =>
      prev.includes(clientId)
        ? prev.filter((id) => id !== clientId)
        : [...prev, clientId]
    );
  };

  // Handle pagination navigation - Updated to use 0-based indexing
  const goToNextPage = () => {
    const nextLimitStart = limitStart + limit;
    onPageChange(nextLimitStart, limit);
  };

  const goToPrevPage = () => {
    const prevLimitStart = Math.max(limitStart - limit, 0); // Changed from 1 to 0
    onPageChange(prevLimitStart, limit);
  };

  return (
    <div className="w-full overflow-x-auto bg-white shadow-lg rounded-2xl p-6">
      <table className="w-full table-auto border-collapse">
        <thead>
          <tr className="bg-gray-100 text-left text-sm font-semibold">
            {(type === "clients" ||
              type == "eproceeding" ||
              type == "responseoutstandings" ||
              type == "notices") && (
              <th className="p-4 border-b text-center">
                <Checkbox
                  className="table-checkbox"
                  onChange={handleSelectAll}
                  checked={selectedIds.length === data.length}
                  indeterminate={
                    selectedIds.length > 0 && selectedIds.length < data.length
                  }
                />
              </th>
            )}
            {columns.map((col, index) => (
              <th
                align={"center"}
                key={index}
                className="p-4 border-b f text-gray-700 font-semibold"
                style={{ fontFamily: "sans-serif" }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 && !isLoading ? (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="border-b hover:bg-gray-50 transition-all duration-200"
              >
                {(type === "clients" ||
                  type == "eproceeding" ||
                  type == "responseoutstandings" ||
                  type == "notices") && (
                  <td className="p-4 text-center">
                    <Checkbox
                      className="table-checkbox"
                      disabled={
                        type == "clients"
                          ? row?.disabled == 1
                            ? true
                            : false
                          : false
                      }
                      checked={selectedIds.includes(row.name)}
                      onChange={() => handleSelectClient(row.name)}
                    />
                  </td>
                )}
                {columns.map((col, colIndex) => {
                  if (col.render) {
                    return (
                      <td
                        key={colIndex}
                        align="center"
                        className="p-4 cursor-pointer"
                        onClick={() => {
                          if (col.key == "client_name") {
                            handleRowClick(row);
                          }
                        }}
                      >
                        <>{col.render(row)}</>
                      </td>
                    );
                  }
                  return (
                    <td
                      key={colIndex}
                      align="center"
                      className="p-4 cursor-pointer text-gray-700 hover:text-blue-500 transition-all duration-200"
                      onClick={() => {
                        handleRowClick(row);
                      }}
                      style={{ fontFamily: "sans-serif" }}
                    >
                      {row[col.key]}
                    </td>
                  );
                })}
              </tr>
            ))
          ) : !isLoading && data.length == 0 ? (
            <tr>
              <td
                colSpan={columns.length + 1}
                className="p-6 text-center text-gray-500"
              >
                No Data
              </td>
            </tr>
          ) : (
            <tr>
              <td
                colSpan={columns.length + 1}
                className="p-6 text-center text-gray-500"
              >
                <Spin tip="Loading..." size="large" />
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {/* Pagination Controls */}
      {isPagination && totalRecords > 0 ? (
        <div className="flex justify-between items-center mt-6">
          <button
            className={`px-6 py-3 bg-gray-300 rounded-lg text-sm font-semibold text-gray-700 exempt-from-readonly ${
              currentPage === 1
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-gray-400"
            }`}
            onClick={goToPrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className="font-medium text-sm text-gray-700 ">
            Page {currentPage} of {totalPages || 1}
          </span>
          <button
            className={`px-6 py-3 bg-gray-300 rounded-lg text-sm font-semibold text-gray-700 exempt-from-readonly ${
              currentPage === totalPages || totalPages === 0
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-gray-400"
            }`}
            onClick={goToNextPage}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            Next
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
